import { Grid_List } from '@app/post-lists/grid-list'
import ClickEvent = JQuery.ClickEvent
import { GT_Project, Project_Status } from '../../types/projects'
import { GT_User } from '../../types/globals'
import SubmitEvent = JQuery.SubmitEvent
import { bus } from '@app/core/bus'
import { Toast } from '@app/utils/toast'
import { Status_Workers, Status_Workers_Status } from '../../types/workers'
import { Action_Tab } from '../../types/wordpress-globals'

export abstract class Workers_Controller {}

export abstract class Manage_Status_Workers_Presenter {
    service
    modal

    protected constructor() {
        this.modal = new Manage_Status_Workers_Modal()
        this.service = new Manage_Status_Workers_Service()
    }

    ready(): void {
        this.init_forms()
        this.init_bus_events()
    }

    init_forms() {
        jQuery( '#form-project-status-worker-edit' ).form(
            {

                // @ts-expect-error Overload
                onSuccess: ( e: SubmitEvent ) => this.on_update_status_workers_form_success( e ),
                onFailure: app.show_toast_invalid_form, // wichtig: return false nötig, sonst Submit Event.
            }
        )
    }

    init_bus_events() {
        bus.on( 'update-status-workers:ajax:success', ( project: GT_Project ) => this.on_update_status_workers_ajax_success( project ) )
    }

    on_update_status_workers_form_success( e: SubmitEvent ) {
        console.log( 'update status workers', e.currentTarget )

        // enable AJAX
        e.preventDefault()

        const form = jQuery( e.currentTarget )
        const form_data: string = form.serialize()

        const post_id = form.find( 'input[name="post-id"]' ).val() as number

        this.service.ajax_update_status_workers( post_id, form_data )
    }

    abstract on_update_status_workers_ajax_success( project: GT_Project ): void
}

export class Project_Manage_Status_Workers_Presenter extends Manage_Status_Workers_Presenter {
    constructor() {
        super()
    }

    ready() {
        super.ready()
        this.init_actions()
    }

    init_actions() {
        jQuery( '[data-action="update-status-worker"]' ).on( 'click', ( e: ClickEvent ) => this.init_modal_update_status_worker( e ) )
    }

    init_modal_update_status_worker( e: ClickEvent ): void {
        let status: Action_Tab = action_tab

        if ( action_tab === 'planning' ) {
            const segment = e.currentTarget.closest( '.meta-segment' )
            status = segment.dataset.projectStatus as Status_Workers_Status
        }

        if ( status === 'data' || status === 'planning' ) {
            throw new Error( 'keine Mitarbeiter für diesen Status' )
        }

        const status_workers = project.get_meta_value( 'project-status-workers' )

        this.modal.init_modal_update_status_worker( project.post_id, status, status_workers )
    }

    on_update_status_workers_ajax_success( project: GT_Project ) {

        // @ts-expect-error meta.js
        update_meta_list_item( 'project-status-workers', project.status_workers )
    }
}

export class List_Manage_Status_Workers_Presenter extends Manage_Status_Workers_Presenter {
    list: Grid_List

    constructor( list: Grid_List ) {
        super()
        this.list = list
    }

    ready() {
        super.ready()
        this.init_events()
    }

    init_events() {
        jQuery( this.list.get_container() ).on(
            'click',
            ( e ) => {
                const target: HTMLElement|null = e.target.closest( '.column-item' )

                if ( ! target ) {
                    return
                }

                console.log( 'list click', e.target, target )

                if ( e.target.dataset.action === 'update-project-status-workers' ) {
                    console.log( 'click status workers' )
                    this.init_modal_update_status_worker( target )
                    return
                }
            }
        )
    }

    init_modal_update_status_worker( target: HTMLElement ): void {
        const post_id: number = Number( target.dataset.postId )

        const project: GT_Project|undefined = gt_results.projects.find( ( el: GT_Project ): boolean => el.post_id === post_id )

        if ( ! project ) {
            throw new Error( 'kein Projekt gefunden' )
        }

        const status: Project_Status = project.status?.slug as Project_Status

        if ( status === 'completed' || status === 'planning' ) {
            throw new Error( 'keine Mitarbeiter für diesen Status' )
        }

        const status_workers = project?.status_workers
        this.modal.init_modal_update_status_worker( post_id, status, status_workers )
    }

    on_update_status_workers_ajax_success( _project: GT_Project ) {
        this.list.reload_results()
    }
}

export class Manage_Status_Workers_Service {
    ajax_update_status_workers( post_id: number, form_data: string ) {
        console.log( 'update status worker', post_id, form_data )

        const { nonce, ajax_url } = gt_ajax_object

        const data = {
            action: 'update_project_status_worker',
            post_id,
            form_data,
            nonce,
        }

        console.log( 'AJAX data', data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false,
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                if ( ! response.success ) {
                    Toast.show_ajax_response( response.data.error, 'error' )
                    return
                }

                Toast.show_ajax_response( response.toast )

                bus.emit( 'update-status-workers:ajax:success', response.project )

                app.close_modals()
            }
        )
    }
}

export class Manage_Status_Workers_Modal {
    init_modal_update_status_worker( post_id: number, status: Status_Workers_Status, status_workers: Status_Workers ): void {
        console.log( 'init modal: update status worker', post_id, status, status_workers )

        const modal    = jQuery( '[data-modal="project-status-worker-edit"]' )
        const form     = jQuery( '#form-project-status-worker-edit' )
        const dropdown = jQuery( '#project-status-worker-edit' )

        // resets.
        dropdown.dropdown( 'clear' )

        // sets.
        if ( status_workers?.[status] ) {

            // @ts-expect-error Overload
            dropdown.dropdown( 'set selected', status_workers[status].flatMap( ( user: GT_User ) => user.id ) )
        }

        modal.find( 'input[name="project-status"' ).val( status )
        form.find( 'input[name="post-id"' ).val( post_id )

        modal.modal( { autofocus: false } ).modal( 'show' )
    }
}
